var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/device/domesticWater","frame-title":"生活水"}})
}
var staticRenderFns = []

export { render, staticRenderFns }